import React from "react";
import PropTypes from "prop-types";
import Sidebar from "../Sidebar";
import Header from "../HeaderMobile";

import styles from "./MainApp.layouts.DesktopLayout.module.scss";
export class DesktopMainLayout extends React.Component {
  render() {
    const {
      content,
      headerTitle,
      headerOptions,
      headerOptionsIcons,
      goBackFunc,
      navHidden,
      headerButtonLabel,
      headerButtonHandler,
      headerButtonState,
      customButtons,
      closeFunc,
      isScrollable
    } = this.props;

    const containerClasses = `${styles["right-layout-container"]} ${
      isScrollable ? styles["is-scrollable"] : ""
    }`;

    return (
      <div className={styles["desktop-main-layout-container"]}>
        <div className={styles["desktop-nav"]}>
          <Sidebar />
        </div>
        <div className={containerClasses}>
          <Header
            title={headerTitle}
            options={headerOptions}
            optionsIcons={headerOptionsIcons}
            goBackFunc={goBackFunc}
            buttonLabel={headerButtonLabel}
            buttonHandler={headerButtonHandler}
            buttonState={headerButtonState}
            content={customButtons}
            closeFunc={closeFunc}
          ></Header>
          {isScrollable ? (
            <div style={{ flex: 1, overflowY: "auto", width: "100%" }}>
              {content}
            </div>
          ) : (
            content
          )}
        </div>
        {!navHidden && (
          <div className={styles["mobile-nav"]}>
            <Sidebar></Sidebar>
          </div>
        )}
      </div>
    );
  }
}

DesktopMainLayout.propTypes = {
  content: PropTypes.any,
};

export default DesktopMainLayout;
